export default "__VITE_ASSET__CY$1a0X7__"